/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import baseApi from '@features/base/BaseSlice';
import { CamelToSnakeCaseNested } from '@helpers/index';
import {
  AccessPerformanceParams,
  AccessesPerformanceApiProps,
  AccessParamsProps,
  AccessesApiProps,
  AccessStaffingTableParams,
  AccessesStaffingTableApiProps,
  AccessByDocumentApiProps,
  AccessByDocumentParams,
  SectionAccessParamsProps,
  AccessContractorPerformanceParams,
  AccessAreaSectionPerformanceParams,
  EventsParams,
  EventsApiProps,
  AccessApiProps,
  CreateManualAccessParams,
  UpdateManualAccessParams,
  DeleteManualAccessParams,
  ManualAccessPreviewApiProps,
  CreateManualMarkImportParams,
  CreateManualMarkImportResponse,
} from './types';
import access from './access';

const accessTag = baseApi.enhanceEndpoints({ addTagTypes: [access.tagType] });
const accessApi = accessTag.injectEndpoints({
  endpoints: (builder) => ({
    getAccessPerformance: builder.query<
      AccessesPerformanceApiProps,
      AccessPerformanceParams
    >(access.getAccessPerformance()),
    getContractorAccessPerformance: builder.query<
      AccessesPerformanceApiProps,
      AccessContractorPerformanceParams
    >(access.getContractorAccessPerformance()),
    getAreaSectionAccessPerformance: builder.query<
      AccessesPerformanceApiProps,
      AccessAreaSectionPerformanceParams
    >(access.getAreaSectionAccessPerformance()),
    getAccesses: builder.query<
      AccessesApiProps,
      CamelToSnakeCaseNested<AccessParamsProps>
    >(access.getAccesses()),
    createManualAccess: builder.mutation<AccessApiProps, CreateManualAccessParams>(
      access.createManualAccess(),
    ),
    updateManualAccess: builder.mutation<AccessApiProps, UpdateManualAccessParams>(
      access.updateManualAccess(),
    ),
    deleteManualAccess: builder.mutation<void, DeleteManualAccessParams>(
      access.deleteManualAccess(),
    ),
    previewManualAccess: builder.mutation<
      ManualAccessPreviewApiProps,
      CreateManualAccessParams
    >(access.previewManualAccess()),
    createManualMarkImport: builder.mutation<
      CreateManualMarkImportResponse,
      CreateManualMarkImportParams
    >(access.createManualMarkImport()),
    getSectionAccesses: builder.query<AccessesApiProps, SectionAccessParamsProps>(
      access.getSectionAccesses(),
    ),
    getAccessStaffingTable: builder.query<
      AccessesStaffingTableApiProps,
      AccessStaffingTableParams
    >(access.getAccessStaffingTable()),
    getAccessByDocuments: builder.query<
      AccessByDocumentApiProps,
      AccessByDocumentParams
    >(access.getAccessByDocuments()),
    getEvents: builder.query<EventsApiProps, EventsParams>(access.getEventsBySite()),
    getWorkerAccesses: builder.query<
      AccessesApiProps,
      CamelToSnakeCaseNested<AccessParamsProps>
    >(access.getWorkerAccess()),
    updateAccessReferencePhoto: builder.mutation<
      { referencePhotoUrl: string },
      { siteId: number; accessId: number; sourceLogId: number }
    >(access.updateReferencePhoto()),
  }),
  overrideExisting: false,
});

export const {
  useGetAccessPerformanceQuery,
  useGetAccessesQuery,
  useCreateManualAccessMutation,
  useUpdateManualAccessMutation,
  useDeleteManualAccessMutation,
  usePreviewManualAccessMutation,
  useCreateManualMarkImportMutation,
  useGetSectionAccessesQuery,
  useGetAccessStaffingTableQuery,
  useGetAccessByDocumentsQuery,
  useGetContractorAccessPerformanceQuery,
  useGetAreaSectionAccessPerformanceQuery,
  useGetEventsQuery,
  useGetWorkerAccessesQuery,
  useUpdateAccessReferencePhotoMutation,
} = accessApi;
